
import {initWebComponent} from "@/helpers/web-component-helper";

export class LanguageComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = '';

        initWebComponent(this, template)
    }
}

